import React from 'react';
import { useSelector } from 'react-redux';
import NextHead from 'next/head';
import { useRouter } from 'next/router';
import Script from 'next/script';

import { getHostname } from '~/src/store/selectors/city';

export interface IHead {
    title?: string,
    url?: string,
    image?: string,
    description?: string,
    relCanonical?: string,
}
const Head = ({
    title = 'Дом.ру',
    url,
    image,
    description,
    relCanonical,
}: IHead) => {
    const hostname = useSelector(getHostname);
    const { asPath } = useRouter();
    const pathWithoutParam = asPath.split('?')[0];
    const canonicalUrl = relCanonical || `https://${hostname}${pathWithoutParam}`;
    const withGoogleoptimize = asPath.indexOf('/bundles-land-new-2') !== -1;

    return (
        <NextHead>
            <title>{title}</title>
            <script type='text/javascript' src='https://api.flocktory.com/v2/loader.js?site_id=6191' async/>
            {withGoogleoptimize && <Script
                src='https://www.googleoptimize.com/optimize.js?id=OPT-MSHKM9J'
                async
            />}
            <meta property='og:type' content='article'/>
            <meta name='twitter:card' content='summary'/>
            <meta name='twitter:creator' content='@domru_'/>
            <meta name='twitter:site' content='@domru_'/>
            <meta name='verify-reformal' content='06f45ba2cda3fd2ce81181b5'/>
            <meta name='yandex-verification' content='36650e0e0c49aa3e'/>
            <meta name='theme-color' content='#FFFFFF'/>
            <link rel='icon' href='/static/core/favicon.ico' sizes='any'/>
            <link rel='icon' href='/static/core/icon.svg' type='image/svg+xml'/>
            <link rel='apple-touch-icon' href='/static/core/apple-touch-icon.png'/>
            <link rel='manifest' href='/static/core/domru.webmanifest'/>
            <noscript>
                <link rel='stylesheet' href='/static/css/carousel.css'/>
            </noscript>
            <meta
                name='viewport'
                content='width=device-width, initial-scale=1, maximum-scale=1, shrink-to-fit=no'
            />
            <meta property='og:site_name' content={title}/>
            <meta property='og:title' content={title}/>
            <meta name='twitter:title' content={title}/>
            <meta name='twitter:image' content={'https://cdn-b2c.dom.ru/logo-full.svg'}/>
            {url && <meta property='og:url' content={url}/>}
            {image && <meta property='og:image' content={image}/>}
            {description &&
                <>
                    <meta property='og:description' content={description}/>
                    <meta name='description' content={description}/>
                    <meta name='twitter:description' content={description}/>
                </>
            }
            {canonicalUrl && <link rel='canonical' href={canonicalUrl}/>}
        </NextHead>
    );
};

export default Head;
